/* eslint-disable react/prop-types */
import CardViewCorrelatedAnnouncement from "./card-view-correlated-announcement";

import GridList from "@/components-library/widgets/grid-list";
import classes from "./correlated-announcement-list.module.scss";
import classNames from "classnames";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
const NO_ITEMS_FOUND = "La soluzione selezionata non presenta bandi cumulabili";

function CorrelatedAnnouncementList({
  announcements,
  admin,
  offer,
  className,
}) {
  const itemComponent = (
    <CardViewCorrelatedAnnouncement admin={admin} offer={offer} />
  );
  if (announcements?.length) {
    return (
      <div className={classNames(classes.container, className)}>
        <GridList
          columns={3}
          items={announcements}
          itemComponent={itemComponent}
        />
      </div>
    );
  } else {
    return (
      <Flex
        align="center"
        direction="column"
        justify="center"
        className={classes.container}
      >
        <Label
          weight="bold"
          tag="h5"
          color="secondary"
          align="start"
          className={classes.title}
        >
          {NO_ITEMS_FOUND}
        </Label>
      </Flex>
    );
  }
}

export default CorrelatedAnnouncementList;
